// 字體
import "@fontsource/noto-sans/400.css";
import "@fontsource/noto-sans/500.css";
import "@fontsource/noto-sans/600.css";
import "@fontsource/noto-sans/700.css";
import "@fontsource-variable/onest/wght.css";
import "@fontsource/inter/400.css";

// 套件
import AOS from 'aos';
import { CountUp } from 'countup.js';

import 'lite-youtube-embed';
import 'lite-youtube-embed/src/lite-yt-embed.css';

import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, EffectFade , Thumbs } from 'swiper/modules';
import 'swiper/css/bundle';

// 客製 - H2側欄快捷
import './js/article_sidemenu';

Swiper.use([Navigation, Pagination, Autoplay, EffectFade, Thumbs]);
window.Swiper = Swiper;

AOS.init({
  duration: 600,
  once: true,
  // 自動化測試（Selenium/Capybara 等）不會觸發真實使用者的捲動事件，
  // 會導致 data-aos 區塊永遠停留在 opacity:0 的初始狀態，
  // 透過 navigator.webdriver 偵測自動化瀏覽器並停用動畫，不影響真實使用者。
  disable: () => navigator.webdriver,
});

// JavaScript
$(document).ready( function () {
  // transparent header
  function headerScroll() {
    if ($(window).scrollTop() > 100) {
      $('.header').addClass("min-header");
    } else {
      $('.header').removeClass("min-header");
    }
  }
  headerScroll();
  $(window).on('scroll', function () {
    headerScroll();
  });

  $('.header-mobile-menu').on('click', function () {
    $(this).toggleClass('active');
    $('.header').toggleClass('active');
    $('.header-menu-outer').toggleClass('active');
    $('.header-overlay').toggleClass('active');
  });

  $('.header-menu-link .menu-dropdown-toggle').on('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    if (!window.matchMedia('(max-width: 767px)').matches) return;

    const $item = $(this).closest('.header-menu-link');
    $item.toggleClass('active').siblings().removeClass('active');
  });


  // 延遲初始化 Swiper (支援同一頁面多組相同 class 的輪播各自獨立初始化)
  function lazyInitSwiper(selector, configFactory) {
    const elements = document.querySelectorAll(selector); // 改用 querySelectorAll,抓出所有符合的輪播
    if (!elements.length) return;

    elements.forEach((el) => {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // configFactory 是函式時,傳入「這一組」的容器,讓每組能各自算出自己的 nextEl/prevEl
            const config = typeof configFactory === 'function' ? configFactory(el) : configFactory;
            new Swiper(el, config); // 直接傳入「這一個」DOM 元素,而不是字串選擇器
            obs.disconnect();
            AOS.refresh();
          }
        });
      }, { rootMargin: '500px' });
      observer.observe(el);
    });
  }

  // 首頁輪播
  if ( $('#indexBanner').length > 0 ) {
    var indexBanner = new Swiper('#indexBanner', {
      effect: 'fade',
      autoplay: {
        delay: 5000,
      },
      loop: true,
      peed: 1000,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
    });
  }

  // 首頁 - promises 項目輪播
  if ( $('#homePromisesSwiper').length > 0 ) {
    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('#homePromisesSwiper', {
    // var homePromisesSwiper = new Swiper("#homePromisesSwiper", {
      watchOverflow: true,
      autoplay: {
        delay: 3000,
      },
      slidesPerView: 2,
      spaceBetween: 12,
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 4,
          spaceBetween: 26,
        },
        1025: { // >= 1025px 時
          slidesPerView: 3,
          spaceBetween: 26,
        },
      },
    });
  }

  // 首頁-產品分類輪播
  if ( $('#homeProductsCategorySwiper').length > 0 ) {
    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('#homeProductsCategorySwiper', {
    // var homeProductsCategorySwiper = new Swiper("#homeProductsCategorySwiper", {
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 15,
      navigation: {
        nextEl: '.home-products-category-swiper-wrap .swiper-button-next',
        prevEl: '.home-products-category-swiper-wrap .swiper-button-prev',
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 5,
          spaceBetween: 25,
        },
        1025: { // >= 1025px 時
          slidesPerView: 4,
          spaceBetween: 25,
        },
        769: { // >= 769px 時
          slidesPerView: 3,
          spaceBetween: 25,
        },
        641: { // >= 641px 時
          slidesPerView: 2,
          spaceBetween: 15,
        },
      },
    });
  }

  // 首頁-產品輪播
  if ( $('#homeProductsSwiper').length > 0 ) {
    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('#homeProductsSwiper', {
    // var homeProductsSwiper = new Swiper("#homeProductsSwiper", {
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.home-products-swiper-wrap .swiper-button-next',
        prevEl: '.home-products-swiper-wrap .swiper-button-prev',
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1025: { // >= 1025px 時
          slidesPerView: 3,
          spaceBetween: 24,
        },
        641: { // >= 641px 時
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
    });
  }

  // 首頁-最新消息輪播
  if ( $('#homeNewsSwiper').length > 0 ) {
    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('#homeNewsSwiper', {
    // var homeNewsSwiper = new Swiper("#homeNewsSwiper", {
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.home-news-swiper-wrap .swiper-button-next',
        prevEl: '.home-news-swiper-wrap .swiper-button-prev',
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1025: { // >= 1025px 時
          slidesPerView: 3,
          spaceBetween: 24,
        },
        641: { // >= 641px 時
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
    });
  }

  // 產品彙整/分類彙整頁-產品分類輪播
  if ( $('#productsCategorySwiper').length > 0 ) {
    // 找出目前作用中分類的 index
    var slides = document.querySelectorAll('#productsCategorySwiper .swiper-slide');
    var activeIndex = 0;
    slides.forEach(function (slide, index) {
      if (slide.querySelector('.products-category-toggle.active')) {
        activeIndex = index;
      }
    });

    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('#productsCategorySwiper', {
    // var productsCategorySwiper = new Swiper("#productsCategorySwiper", {
      watchOverflow: true,
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: '.products-category-swiper-wrap .swiper-button-next',
        prevEl: '.products-category-swiper-wrap .swiper-button-prev',
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 6,
          spaceBetween: 16,
        },
        1025: { // >= 1025px 時
          slidesPerView: 5,
          spaceBetween: 16,
        },
        769: { // >= 769px 時
          slidesPerView: 4,
          spaceBetween: 16,
        },
        641: { // >= 641px 時
          slidesPerView: 3,
          sspaceBetween: 16,
        },
      },
      on: {
        init: function () {
          // 取得目前螢幕寬度下實際套用的 slidesPerView 數量
          var visibleCount = this.params.slidesPerView;
          if (typeof visibleCount !== 'number') {
            visibleCount = this.slidesPerViewDynamic ? this.slidesPerViewDynamic() : 1;
          }
          // 只有當 active 項目「超出」第一頁可視範圍時才捲動過去
          if (activeIndex >= visibleCount) {
            this.slideTo(activeIndex, 0); // 第二個參數 0 代表不要動畫, 直接跳過去
          }
        }
      }
    });
  }

  // 產品內頁-產品輪播圖
  if ( $('#productSlider').length != 0 ) {
    // 產品縮圖輪播
    var productThumbsSlider = new Swiper("#productThumbsSlider", {
      observer: true, 
      observeParents: true,
      spaceBetween: 14,
      slidesPerView: 3,
      freeMode: true,
      watchSlidesProgress: true,
      slideToClickedSlide: true,
      on: {
        init: function () {
          if (this.slides.length <= 1) {
            $(this.el).addClass('is-single');
          }
        },
      },
    });
    // 產品大圖輪播
    var productSlider = new Swiper("#productSlider", {
      observer: true, 
      observeParents: true,
      navigation: {
        nextEl: '.product-slider-wrap .swiper-button-next',
        prevEl: '.product-slider-wrap .swiper-button-prev',
      },
      thumbs: {
        swiper: productThumbsSlider,
      },
    });
  }

  // 產品內頁 - promises 項目輪播
  if ( $('#productPromisesSwiper').length > 0 ) {
    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('#productPromisesSwiper', {
    // var productPromisesSwiper = new Swiper("#productPromisesSwiper", {
      watchOverflow: true,
      autoplay: {
        delay: 3000,
      },
      slidesPerView: 2,
      spaceBetween: 20,
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 7,
          spaceBetween: 20,
        },
        1025: { // >= 1025px 時
          slidesPerView: 6,
          spaceBetween: 20,
        },
        768: { // >= 768px 時
          slidesPerView: 4,
          spaceBetween: 12,
        },
        641: { // >= 641px 時
          slidesPerView: 3,
          spaceBetween: 12,
        },
      },
    });
  }

  // 產品內頁-相關產品輪播
  if ( $('#releatedProductsSwiper').length > 0 ) {
    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('#releatedProductsSwiper', {
    // var releatedProductsSwiper = new Swiper("#releatedProductsSwiper", {
      watchOverflow: true,
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.releated-products-swiper-wrap .swiper-button-next',
        prevEl: '.releated-products-swiper-wrap .swiper-button-prev',
      },
      breakpoints: {
        1281: { // >= 1281px 時
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1025: { // >= 1025px 時
          slidesPerView: 3,
          spaceBetween: 24,
        },
        641: { // >= 641px 時
          slidesPerView: 2,
          spaceBetween: 16,
        },
      },
    });
  }

  // 文章分類頁-Topic文章輪播
  if ($('.topic-news-swiper').length > 0) {
    // 使用 lazyInitSwiper 函式延遲載入
    lazyInitSwiper('.topic-news-swiper', (swiperEl) => {
      // 從目前這個 .topic-news-swiper 往上找到自己所屬的 wrap,
      // 再從這個 wrap「內部」找按鈕,確保抓到的是自己專屬的上一頁/下一頁
      const wrap = swiperEl.closest('.topic-news-swiper-wrap');
      return {
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 10,
        navigation: {
          nextEl: wrap.querySelector('.swiper-button-next'),
          prevEl: wrap.querySelector('.swiper-button-prev'),
        },
        breakpoints: {
          1281: {
            slidesPerView: 4,
            spaceBetween: 20,
          },
          1025: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          641: {
            slidesPerView: 2,
            spaceBetween: 10,
          },
        },
      };
    });
  }

  // 最新消息分類頁 - 快捷側邊欄顯示時機: 捲動到第二個 Topic 區塊時
  if ( $('.post-topic-section').length > 0 ) {
    const $sidemenu = $('.js-post-sidemenu');
    const $sections = $('.post-topic-wrap .post-topic-section');
    if ($sidemenu.length > 0 && $sections.length >= 2) {
      const targetSection = $sections.eq(1).get(0);
      const triggerOffset = 300; // 提前觸發的距離 px
      let sidemenuTicking = false;
      function updateSidemenuVisibility() {
        const rect = targetSection.getBoundingClientRect();
        $sidemenu.toggleClass('is-show', rect.top <= triggerOffset);
        sidemenuTicking = false;
      }
      function onSidemenuScroll() {
        if (!sidemenuTicking) {
          window.requestAnimationFrame(updateSidemenuVisibility);
          sidemenuTicking = true;
        }
      }
      $(window).on('scroll resize', onSidemenuScroll);
      updateSidemenuVisibility(); // 初始化時先判斷一次
    }
  }

  // 前台聯絡表單: select 文字樣式設定
  function updateSelectColor(select) {
    $(select).toggleClass('val-empty', $(select).val() === '')
  }
  if ( $('.form-select').length > 0 ) {
    $('.form-select').each(function() {
      updateSelectColor(this);
    })
    $(document).on('change', '.form-select', function() {
      updateSelectColor(this);
    })
  }

  // 內容 tabs
  if ( $('#js-nav-tabs').length != 0 ) {
    const $tabsNavItem = $('#js-nav-tabs').find('.nav-tabs-toggle');
    const $tabsContentWrap = $('#js-tab-content').find('.tab-pane');
    $tabsNavItem.on('click', function() {
      $tabsNavItem.removeClass('active');
      $(this).addClass('active');
      let targetContent = $(this).attr('data-target');
      $tabsContentWrap.removeClass('active');
      $(targetContent).addClass('active');
    });
  }

  // 彙總頁分類 Tabs
  if ( $('#pageCateSwiper').length != 0 ) {
    var swiper = new Swiper("#pageCateSwiper", {
      slidesPerView: "auto",
      spaceBetween: 6,
      freeMode: true,
      watchOverflow: true,
      navigation: {
        nextEl: ".page-cate-group .swiper-button-next",
        prevEl: ".page-cate-group .swiper-button-prev",
      },
      breakpoints: {
        1281: { // >= 1281px 時
          spaceBetween: 12,
        },
      },
    });

    // 分類Tabs-水平置中
    if ( $('.js-page-cate-group-center').length != 0 ) {
      let totalWidth = 0;
      function setSwiperCenter() {
        totalWidth = 0;
        $('#pageCateSwiper .swiper-slide').each(function (index) {
          totalWidth += $(this).width();
          return totalWidth;
        });
        if ( $('#pageCateSwiper').width() > totalWidth ) {
          $('#pageCateSwiper .swiper-wrapper').css('justify-content', 'center');
        } else {
          $('#pageCateSwiper .swiper-wrapper').css('justify-content', 'flex-start');
        }
      }
      setSwiperCenter();
      let pageCateResizeTimer; // resize計時器
      $(window).on('resize', function() {
        clearTimeout(pageCateResizeTimer);
        pageCateResizeTimer = setTimeout(function () {
          setSwiperCenter();
        }, 300);
      });
    }
  }

  // accordion
  $('.accordion-item .accordion-title-group').click(function () {
    $(this).parent('.accordion-item').toggleClass('active').siblings().removeClass('active').find('.accordion-content').slideUp(200);
    $(this).siblings('.accordion-content').slideToggle(200);
  });

  // 關於我們頁 banner 滾動視差
  const $aboutBanner = $('.about-banner');
  if ( $aboutBanner.length > 0 ) {
    const $layers = $aboutBanner.find('[data-parallax]');
    if (!$layers.length) return;
    let ticking = false;

    function updateParallax() {
      const rect = $aboutBanner[0].getBoundingClientRect();
      const windowHeight = $(window).height();
      // banner 離開可視範圍就不計算
      if (rect.bottom < 0 || rect.top > windowHeight) {
        ticking = false;
        return;
      }
      // banner 頂部相對於視窗頂部的距離；往下捲動時會變成負值
      const scrolled = -rect.top;
      $layers.each(function () {
        const $layer = $(this);
        const speed = parseFloat($layer.data('parallax-speed')) || 0;
        const offset = scrolled * speed * -1; // 負值 = 往上移動
        $layer.css('transform', 'translateY(' + offset + 'px)');
      });
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }

    $(window).on('scroll resize', onScroll);
    updateParallax(); // 初始化
  }

  // 數字跑跑動畫
  if ( $('.counter').length > 0 ) {
    $('.counter').each(function() {
      let $el = $(this);
      let targetId = $el.attr('id');  // 元素 id
      let endVal = parseFloat($el.attr('data-target')); // 數字, 讀取 data-target
      let decimals = parseInt($el.attr('data-decimal-places')) || 0; // 小數位數，預設 0, 讀取 data-decimal-places

      // 初始化 CountUp
      let countUp = new CountUp(targetId, endVal, {
        enableScrollSpy: true,  // 透過捲動觸發
        scrollSpyOnce: false,  // 只跑一次
        decimalPlaces: decimals, // 顯示小數位數
        separator: '', // 設定千分位符號為空字串
      });
    });
  }
  
});
